import React from 'react';

function CloseIcon() {

	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2063_11527)">
				<path fillRule="evenodd" clipRule="evenodd" d="M10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.71962 5.7197C6.01252 5.42681 6.48739 5.42681 6.78028 5.7197L9.99995 8.93937L13.2196 5.7197C13.5125 5.42681 13.9874 5.42681 14.2803 5.7197C14.5732 6.01259 14.5732 6.48747 14.2803 6.78036L11.0606 10L14.2803 13.2197C14.5732 13.5126 14.5732 13.9875 14.2803 14.2804C13.9874 14.5733 13.5125 14.5733 13.2196 14.2804L9.99995 11.0607L6.78028 14.2804C6.48739 14.5733 6.01252 14.5733 5.71962 14.2804C5.42673 13.9875 5.42673 13.5126 5.71962 13.2197L8.93929 10L5.71962 6.78036C5.42673 6.48747 5.42673 6.01259 5.71962 5.7197Z" fill="#D4D6D7"/>
			</g>
			<defs>
				<clipPath id="clip0_2063_11527">
					<rect width="20" height="20" fill="white"/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default CloseIcon;